module.exports = __webpack_public_path__ + "media/stylesheets/images/main/sample576x281-5fd2272f01fa04f854a8d6631d45733c.jpeg";